import React from "react"
import { BigNumber } from "ethers"
import { useTranslation } from "react-i18next"
import boostPools from "src/constants/boostPools"
import { Box } from "@mui/material"
import { formatNumber, getRawAmount } from "src/utils/parseStringToBigNumber"
import { formatLockPeriod } from "../../helpers"
import Button from "src/components/Button"
import Warning from "./Warning"
import { XFER } from "src/constants"
import UpgradeDetails from "./UpgradeDetails"
import TransactionSummary from "src/components/TransactionSummary"

interface ConfirmStepProps {
  amount: BigNumber
  onConfirm: () => void
  selectedPool: number
  currentPool: number
  lastUnlockTime: number
}

const ConfirmStep = ({
  onConfirm,
  amount,
  selectedPool,
  currentPool,
  lastUnlockTime,
}: ConfirmStepProps) => {
  const { t } = useTranslation()

  const selectedPoolInfo = boostPools.find((pool) => pool.pid === selectedPool)

  const formattedAmount = getRawAmount(amount, XFER.decimals)

  return (
    <Box>
      {selectedPoolInfo && (
        <TransactionSummary
          data={[
            {
              label: t("Upgrade"),
              customElement: (
                <Box display="flex" alignItems="center">
                  <Box mr={1}>
                    {formatLockPeriod(selectedPoolInfo.lockPeriod)}
                  </Box>
                  <img src={selectedPoolInfo.imgSrc} width={16} height={16} />
                </Box>
              ),
            },
            {
              label: t("Deposit"),
              amount: formatNumber(formattedAmount, 2, 6),
              token: XFER,
            },
          ]}
        />
      )}

      <UpgradeDetails
        currentPool={currentPool}
        selectedPool={selectedPool}
        lastUnlockTime={lastUnlockTime}
      />
      <Warning />
      <Button fullWidth onClick={onConfirm}>
        {t("Confirm Upgrade")}
      </Button>
    </Box>
  )
}

export default ConfirmStep
